import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const icons = {
  package: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M16.5 9.4l-9-5.19"/><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/>
    </svg>
  ),
  mail: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/>
    </svg>
  ),
  stamp: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M5 21h14"/><path d="M9 21v-4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v4"/><path d="M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z"/>
    </svg>
  ),
  printer: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="6 9 6 2 18 2 18 9"/><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/><rect x="6" y="14" width="12" height="8"/>
    </svg>
  ),
  shred: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="6" width="20" height="8" rx="1"/><path d="M17 14v7"/><path d="M7 14v7"/><path d="M12 14v7"/><path d="M4 6V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2"/>
    </svg>
  ),
  globe: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
    </svg>
  ),
  scan: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 7V5a2 2 0 0 1 2-2h2"/><path d="M17 3h2a2 2 0 0 1 2 2v2"/><path d="M21 17v2a2 2 0 0 1-2 2h-2"/><path d="M7 21H5a2 2 0 0 1-2-2v-2"/><line x1="7" y1="12" x2="17" y2="12"/>
    </svg>
  ),
  layers: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="12 2 2 7 12 12 22 7 12 2"/><polyline points="2 17 12 22 22 17"/><polyline points="2 12 12 17 22 12"/>
    </svg>
  ),
  arrowRight: (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>
    </svg>
  ),
  mailboxSmall: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="5" y="8" width="14" height="11" rx="1.5"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/><circle cx="12" cy="14" r="1"/>
    </svg>
  ),
  mailboxMedium: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="7" width="18" height="13" rx="1.5"/><path d="M8 7V5a4 4 0 0 1 8 0v2"/><circle cx="12" cy="14" r="1.2"/>
    </svg>
  ),
  mailboxLarge: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="6" width="20" height="15" rx="2"/><path d="M7 6V4a5 5 0 0 1 10 0v2"/><circle cx="12" cy="14" r="1.5"/>
    </svg>
  ),
  check: (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="20 6 9 17 4 12"/>
    </svg>
  ),
};

const specials = [
  {
    icon: icons.mailboxSmall,
    title: 'Small Mailbox',
    audience: 'For Individuals',
    perks: ['Real street address', 'Mail receiving', 'Package acceptance'],
    tiers: [
      { term: '1-Year Agreement', price: 10, badge: 'Best Value' },
      { term: '6-Month Agreement', price: 11 },
      { term: '3-Month Agreement', price: 12 },
    ],
  },
  {
    icon: icons.mailboxMedium,
    title: 'Medium Mailbox',
    audience: 'For Individuals & Business',
    featured: true,
    perks: ['Real street address', 'Larger package capacity', 'Business-ready'],
    tiers: [
      { term: '1-Year Agreement', price: 16, badge: 'Best Value' },
      { term: '6-Month Agreement', price: 18 },
      { term: '3-Month Agreement', price: 21 },
    ],
  },
  {
    icon: icons.mailboxLarge,
    title: 'Large Mailbox',
    audience: 'For Individuals, Business & Corporate',
    perks: ['Real street address', 'High-volume capacity', 'Corporate accounts'],
    tiers: [
      { term: '1-Year Agreement', price: 26, badge: 'Best Value' },
      { term: '6-Month Agreement', price: 28 },
      { term: '3-Month Agreement', price: 31 },
    ],
  },
];

const services = [
  {
    icon: icons.package,
    title: 'Packing & Shipping',
    description: 'Professional packing services using quality materials to ensure your items arrive safely. We ship through major carriers with competitive pricing and full tracking capabilities.',
    tags: ['Multiple Carriers', 'Tracking', 'Insurance'],
  },
  {
    icon: icons.mail,
    title: 'Private Mailboxes',
    description: 'Rent a private mailbox with a real street address — not a P.O. Box. Receive all your mail and packages at one secure, convenient location. Perfect for businesses and individuals who want a professional address.',
    tags: ['Real Street Address', 'Package Receiving', 'Secure', 'Mail Forwarding'],
  },
  {
    icon: icons.globe,
    title: 'International Shipping',
    description: 'Ship anywhere in the world with confidence. We handle customs forms, packaging requirements, and carrier selection to get your packages delivered internationally at the best available rates.',
    tags: ['Worldwide', 'Customs Forms', 'Best Rates', 'Tracking'],
  },
  {
    icon: icons.stamp,
    title: 'Notary Public',
    description: 'Certified notary services available during business hours. Get your important legal documents, real estate papers, and other official documents notarized quickly and professionally.',
    tags: ['Legal Documents', 'Real Estate', 'Quick Service', 'Certified'],
  },
  {
    icon: icons.printer,
    title: 'Print, Copy & Fax',
    description: 'High-quality color and black & white printing, photocopying, and fax services. Whether you need one page or a hundred, we handle your document needs with professional-grade equipment.',
    tags: ['Color Printing', 'B&W Copies', 'Fax', 'Email to Print'],
  },
  {
    icon: icons.scan,
    title: 'Scanning & Email',
    description: 'Digitize your documents with our professional scanning services. We can scan to email, USB drive, or cloud storage. Perfect for archiving important documents or sending digital copies.',
    tags: ['Scan to Email', 'Digital Copies', 'High Resolution', 'USB Drive'],
  },
  {
    icon: icons.shred,
    title: 'Secure Shredding',
    description: 'Protect your identity and sensitive information with our secure document shredding service. We ensure complete destruction of confidential documents, financial records, and personal information.',
    tags: ['Confidential', 'Identity Protection', 'On-Site', 'Certified'],
  },
  {
    icon: icons.layers,
    title: 'Laminating',
    description: 'Preserve and protect your important documents, photos, IDs, and certificates with professional laminating services. Available in various sizes from business card to poster size.',
    tags: ['Documents', 'Photos', 'IDs', 'All Sizes'],
  },
];

function Services() {
  useEffect(() => {
    document.title = 'Services | Royal Parcel — Shipping, Mailboxes, Notary & More in North Hollywood';
    document.querySelector('meta[name="description"]')?.setAttribute('content',
      'Royal Parcel services in North Hollywood: packing & shipping, private mailbox rental with real street address, notary public, printing, copying, fax, scanning, secure shredding, laminating, and international shipping. Visit us on Magnolia Blvd.'
    );
  }, []);

  return (
    <>
      {/* Page Hero */}
      <section className="page-hero">
        <div className="container">
          <p className="section-overline section-overline--light" style={{ justifyContent: 'center' }}>
            <span style={{ display: 'none' }}>—</span>What We Offer
          </p>
          <h1>Our Services</h1>
          <p>Comprehensive shipping, mailing, and business services — all under one roof with royal care.</p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="services-page-grid">
        <div className="container">
          <div className="services-full-grid">
            {services.map((service, index) => (
              <div className="service-full-card" key={index}>
                <div className="service-full-card-header">
                  <div className="service-full-icon">{service.icon}</div>
                  <h3>{service.title}</h3>
                </div>
                <p>{service.description}</p>
                <div className="features-list">
                  {service.tags.map((tag, i) => (
                    <span className="feature-tag" key={i}>{tag}</span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Mailbox Pricing */}
      <section className="specials-section" id="pricing">
        <div className="specials-bg-glow specials-bg-glow--1" aria-hidden="true"></div>
        <div className="specials-bg-glow specials-bg-glow--2" aria-hidden="true"></div>
        <div className="container">
          <div className="section-header" style={{ textAlign: 'center' }}>
            <p className="section-overline section-overline--light" style={{ justifyContent: 'center' }}>
              <span style={{ display: 'none' }}>—</span>Mailbox Rentals
            </p>
            <h2 className="section-title section-title--light">Mailbox Plans &amp; Pricing</h2>
            <p className="section-subtitle section-subtitle--light" style={{ margin: '0 auto', textAlign: 'center' }}>
              Choose the plan that fits — longer agreements unlock better monthly rates.
            </p>
          </div>

          <div className="specials-grid">
            {specials.map((plan, i) => (
              <div className={`specials-card ${plan.featured ? 'specials-card--featured' : ''}`} key={i}>
                {plan.featured && <div className="specials-card-ribbon">Most Popular</div>}
                <div className="specials-card-icon">{plan.icon}</div>
                <h3 className="specials-card-title">{plan.title}</h3>
                <p className="specials-card-audience">{plan.audience}</p>

                <ul className="specials-card-perks">
                  {plan.perks.map((perk, p) => (
                    <li key={p}>
                      <span className="specials-perk-check">{icons.check}</span>
                      {perk}
                    </li>
                  ))}
                </ul>

                <div className="specials-tiers">
                  {plan.tiers.map((tier, t) => (
                    <div className={`specials-tier ${tier.badge ? 'specials-tier--best' : ''}`} key={t}>
                      {tier.badge && <span className="specials-tier-badge">{tier.badge}</span>}
                      <div className="specials-tier-price" aria-label={`$${tier.price} per month`}>
                        <span className="specials-tier-currency">$</span>
                        <span className="specials-tier-amount">{tier.price}</span>
                        <span className="specials-tier-per">/mo</span>
                      </div>
                      <div className="specials-tier-term">{tier.term}</div>
                    </div>
                  ))}
                </div>

                <Link to="/contact" className="btn btn-primary specials-card-cta">
                  Reserve This Mailbox {icons.arrowRight}
                </Link>
              </div>
            ))}
          </div>

          <p className="specials-disclaimer">
            All plans include a real street address (not a P.O. Box), mail receiving, and package acceptance from all major carriers. Visit us in North Hollywood or call <a href="tel:+18182993899">(818) 299-3899</a> to reserve your mailbox.
          </p>
        </div>
      </section>

      {/* Mailbox Application Forms */}
      <section className="forms-section">
        <div className="container">
          <div className="section-header" style={{ textAlign: 'center' }}>
            <p className="section-overline" style={{ justifyContent: 'center' }}>
              <span style={{ display: 'none' }}>—</span>Mailbox Setup
            </p>
            <h2 className="section-title">Mailbox Application Forms</h2>
            <p className="section-subtitle" style={{ margin: '0 auto', textAlign: 'center' }}>
              To set up your private mailbox, you'll need to complete the USPS Form 1583-1.
              Preview or download the forms below and bring them in — we'll help you with the rest.
            </p>
          </div>

          <div className="forms-grid">
            <div className="form-download-card">
              <div className="form-download-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/>
                </svg>
              </div>
              <div className="form-download-info">
                <h3>USPS Form 1583-1</h3>
                <p>Application for Delivery of Mail Through Agent — required to authorize Royal Parcel to receive mail on your behalf.</p>
              </div>
              <div className="form-download-actions">
                <a href="/forms/usps-form-1583-1.pdf" target="_blank" rel="noopener noreferrer" className="btn btn-outline form-btn">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                  Preview
                </a>
                <a href="/forms/usps-form-1583-1.pdf" download className="btn form-btn">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
                  Download
                </a>
              </div>
            </div>

            <div className="form-download-card">
              <div className="form-download-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/>
                </svg>
              </div>
              <div className="form-download-info">
                <h3>USPS Form 1583-2</h3>
                <p>Instructions, definitions, agreement terms, and privacy act statement for the mail delivery application.</p>
              </div>
              <div className="form-download-actions">
                <a href="/forms/usps-form-1583-2.pdf" target="_blank" rel="noopener noreferrer" className="btn btn-outline form-btn">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                  Preview
                </a>
                <a href="/forms/usps-form-1583-2.pdf" download className="btn form-btn">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
                  Download
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cta-banner">
        <div className="container">
          <h2>Need Something Shipped?</h2>
          <p>Bring it to us — we'll take care of the rest. Competitive rates and friendly service guaranteed.</p>
          <Link to="/contact" className="btn">
            Get a Quote {icons.arrowRight}
          </Link>
        </div>
      </section>
    </>
  );
}

export default Services;
